<template>
  <span :class="badgeClasses">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'ThemedBadge',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'secondary', 'destructive', 'outline'].includes(value)
    }
  },
  computed: {
    badgeClasses() {
      const base = 'inline-flex items-center justify-center rounded-md border px-2 py-1 text-xs font-medium whitespace-nowrap transition-all';
      
      const variants = {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        destructive: 'border-transparent bg-destructive text-white',
        outline: 'text-foreground border-border'
      };
      
      return this.cn(base, variants[this.variant]);
    }
  }
}
</script>
